import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function TypeTag({ type }) {
  return type === "research"
    ? <span className="eyebrow !text-[var(--red)] inline-flex items-center gap-1.5"><Lock size={11} /> Peer-reviewed</span>
    : <span className="eyebrow">Analysis</span>;
}

export default function ArticleCard({ a, size = "md", showImage = true }) {
  if (!a) return null;
  return (
    <Link to={`/article/${a.slug}`} className="group block" data-testid={`article-card-${a.slug}`}>
      {showImage && (
        <div className={`img-zoom overflow-hidden bg-[var(--paper-2)] mb-5 ${size === "lg" ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
          <img src={a.image} alt="" className="w-full h-full object-cover grayscale-[60%] group-hover:grayscale-0 transition-[filter] duration-700" loading="lazy" />
        </div>
      )}
      <div className="flex items-center gap-3 mb-3"><TypeTag type={a.type} /><span className="eyebrow">· {a.category}</span></div>
      <h3 className={`f-serif leading-[1.08] tracking-tight group-hover:text-[var(--red)] transition-colors ${size === "lg" ? "text-3xl sm:text-4xl lg:text-[2.9rem]" : size === "sm" ? "text-xl" : "text-2xl"}`}>{a.title}</h3>
      {size !== "sm" && <p className="text-[var(--ink-2)] mt-3 leading-relaxed text-[0.98rem]">{a.dek}</p>}
      <p className="f-mono text-xs text-[var(--muted)] mt-4">{a.author} · {a.read_time} min</p>
    </Link>
  );
}
